(ns core.util.util
  "Various useful utilities`"
  #?(:cljs #_{:clj-kondo/ignore [:refer]} (:require-macros [core.util.util :refer [mmap]]))
  (:require [clojure.string :as str]
            [potpuri.core :as p]))


(defn make-kw
  "Makes keyword from a number as well."
  [x]
  (keyword (cond-> x
             (number? x) str)))


(defn split-kw-path
  ":a.b.c -> [:a :b :c]"
  [kw]
  (when-not (nil? kw)
    (map make-kw (str/split (name (or kw "")) #"\."))))


(defn kw-path
  "a b c       -> :a.b.c
   [a b c]     -> :a.b.c
   a [b nil] c -> :a.b.c
   nil         -> nil"
  [& path]
  (some->> path
           flatten
           (remove nil?)
           not-empty
           (map #(if (keyword? %)
                   (name %)
                   %))
           (str/join ".")
           make-kw))


(defn assoc-when
  "Assocs entries with truthy values into m."
  [m & kvs]
  (apply merge m (filter val (apply hash-map kvs))))


(defn assoc-when-pred
  "Assocs entries into m when pred returns truthy for value."
  [m pred & kvs]
  (apply merge m (filter (comp pred val) (apply hash-map kvs))))


(defn only
  "Returns the sole item in `items`, or nil unless it contains exactly one item."
  [items]
  (when (= 1 (count items))
    (first items)))


#?(:clj
   (defmacro mmap
     "make a hash-map

      given a map `m`, associate values of `kvs` under a keyword
      from that symbols name, e.g.

        (def b 2)
        (mmap {:a 1} b)
          =>  {:a 1 :b 2}

      or, make one from values only
      (mmap b) => {:b 2}"
     {:style/indent 0}
     [m & kvs]
     (let [kvs (if (map? m) kvs (conj kvs m))
           m   (if (map? m) m {})]
       (->> kvs
            (map (fn [sym] [(-> sym name keyword) sym]))
            (into m)))))


(defn get-some
  "Returns the first truthy value in map `m` of the given keys' values.

  For example:
  (get-some {:a 1 :b 2 :c 3 :d false} :e :d :b :a) => 2"
  [m & ks]
  (p/find-first ((apply juxt ks) m) some?))


(defn map-indexed-pred
  "Like `clojure.core/map-indexed`,
   but only indexes items the pred returns truthy for.

   Other items get index nil.
   The items still retain the original ordering.

   For example:
   (map-indexed-pred vector odd? [1 2 3 4 5]
   => [[0 1] [nil 2] [1 3] [nil 4] [2 5]]"
  [f pred coll]
  (->> coll
       (reduce (fn [acc item]
                 (if-not (pred item)
                   (update acc :result conj (f nil item))
                   (-> acc
                       (update :result conj (f (:index acc) item))
                       (update :index inc))))
               {:result []
                :index  0})
       :result))


(defn safe-update-in
  "Like update-in, but does nothing in case the given path does not exist"
  [a-map path f & params]
  (if (empty? path)
    (apply f a-map params)
    (let [[fst & rst] path]
      (if (contains? a-map fst)
        (apply update a-map fst safe-update-in rst f params)
        a-map))))


(defn nil-or-blank? [value]
  (or (nil? value)
      (and (string? value) (str/blank? value))))


(defn nil-or-empty-coll? [v]
  (or (nil? v)
      (and (coll? v) (empty? v))))


(defn blank-string? [value]
  (and (string? value) (str/blank? value)))


(defn max-comparable
  "Like `clojure.core/max` but works with any IComparable items"
  ([x] x)
  ([x y] (if (pos? (compare x y)) x y))
  ([x y & more] (reduce max-comparable (max-comparable x y) more)))


(defn min-comparable
  "Like `clojure.core/min` but works with any IComparable items"
  ([x] x)
  ([x y] (if (neg? (compare x y)) x y))
  ([x y & more] (reduce min-comparable (min-comparable x y) more)))


(defn max-comparable-key
  "Like `clojure.core/max-key` but works with any IComparable items"
  ([_ x] x)
  ([k x y] (if (pos? (compare (k x) (k y))) x y))
  ([k x y & more] (reduce #(max-comparable-key k %1 %2) (max-comparable-key k x y) more)))


(defn stringify-keyword
  "Converts keyword into a string retaining namespace if present
  :keyword -> \"keyword\"
  :namespaced/keyword -> \"namespaced/keyword\"

  Returns other types than keywords as they are."
  [kw]
  (cond
    (qualified-keyword? kw) (str (namespace kw) "/" (name kw))
    (keyword? kw)           (name kw)
    :else                   kw))

(defn distinct-by
  "Returns a lazy sequence of the elements of coll with duplicates, determined by (f item), removed.
  If (f item) produces the same result for multiple items, only the first item will be retained.
  Original order of coll is preserved."
  [f coll]
  (let [step (fn step [seen coll]
               (lazy-seq
                 (when-let [s (seq coll)]
                   (let [item  (first s)
                         fitem (f item)]
                     (if (contains? seen fitem)
                       (step seen (rest s))
                       (cons item (step (conj seen fitem) (rest s))))))))]
    (step #{} coll)))

(defn has-duplicates?
  "Check if `coll` has duplicates."
  [coll]
  (->> coll
       frequencies
       vals
       (some (partial not= 1))
       boolean))


(defn not-empty?
  "If coll is not empty, returns true, else false."
  [coll]
  (boolean (seq coll)))


(defn ->set
  "Returns a set of sequential or scalar `v` or `nil` if `nil`."
  [v]
  (cond
    (set? v) v
    (sequential? v) (set v)
    v #{v}))


(defn insert-at
  "Adds item to the coll at the given index"
  [coll item index]
  (let [[before after] (split-at index coll)]
    (concat before [item] after)))


(defn insert-before
  "Adds item to the coll before the item matching the pred"
  [coll item pred]
  (some->> (p/find-index coll pred)
           (insert-at coll item)))


(defn insert-after
  "Adds item to the coll after the item matching the pred"
  [coll item pred]
  (some->> (p/find-index coll pred)
           inc
           (insert-at coll item)))


(defn remove-blanks [obj]
  (p/remove-vals #(and (string? %) (str/blank? %)) obj))


(defn find-previous-and-next
  "Find neighbor items in collection, e.g.
  (find-previous-and-next [:a :b :c :d] :c) => [:b :d]
  returns nil for out-of-bounds values"
  [coll item]
  (-> (->> (into [nil] coll)
           (partition-all 3 1))
      (p/find-first #(= (second %) item))
      (#(identity [(first %) (nth % 2 nil)]))))


(defn clamp [val min-val max-val]
  (-> val (max min-val) (min max-val)))

(defn mapset
  "map but returns a set, hence deduped;
  Use with caution"
  ([f coll]
   (into #{} (map f) coll))
  ([f c1 c2]
   (into #{} (map f c1 c2)))
  ([f c1 c2 c3]
   (into #{} (map f c1 c2 c3)))
  ([f c1 c2 c3 & colls]
   (into #{} (apply map f c1 c2 c3 colls))))

(defn toggle-in-set
  "Toggles presence of v in set s.
  E.g. (toggle-in-set #{1 2 3} 2) => #{1 3}
       (toggle-in-set #{1 3} 2)   => #{1 2 3}
       (toggle-in-set nil 2)      => #{2}"
  [s v]
  (if (contains? s v)
    (disj s v)
    (conj (or s #{}) v)))
